import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Familiar } from './components/sections/Familiar';
import { Volumes } from './components/sections/Volumes';
import { AlsoReceive } from './components/sections/AlsoReceive';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { About } from './components/sections/About';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full bg-navy-950 font-sans text-white" data-id="element-0" data-mp="23ut9lxqjzq85">
      <MetaPixel data-id="element-1" data-mp="3ikr0e3urxc7u" />
      <main data-id="element-2" data-mp="3ij63w8owfj7c">
        <Hero data-id="element-3" data-mp="3ijfthv617oci" />
        <BeforeAfter data-id="element-4" data-mp="3ihv0i9zd8dgr" />
        <Familiar data-id="element-5" data-mp="3mlj6io8cn0zw" />
        <Volumes data-id="element-6" data-mp="3mkrd9k285fcs" />
        <AlsoReceive data-id="element-7" data-mp="3mk86mzi0yde2" />
        <Bonuses data-id="element-8" data-mp="3mjq2zht18ww4" />
        <Offer data-id="element-9" data-mp="3mj6jvxrnc2gi" />
        <Guarantee data-id="element-10" data-mp="3rcj6y3gog175" />
        <Testimonials data-id="element-11" data-mp="3rbzomln47asl" />
        <About data-id="element-12" data-mp="3rdkkqfp2v1sk" />
        <FAQ data-id="element-13" data-mp="3rd18nfm3z7mg" />
        <FinalCTA data-id="element-14" data-mp="3relu8fqg3g86" />
      </main>
      <Footer data-id="element-15" data-mp="6hq1ea16ddl" />
      <FloatingCTA triggerId="primary-cta" data-id="element-16" data-mp="4wupmfw6qeo" />
      <PurchasePopup data-id="element-17" data-mp="82ohezguggq" />
    </div>;
}